import { useCheckboxState } from '../abstract/checkbox';

export function usePetsFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { checked: pets, setChecked: onPetsChange } = useCheckboxState({
    defaultValue: query.pets,
    filterKey: `pets`,
    setFilters,
    updateQuery,
  });

  return { pets, onPetsChange };
}
